export default __webpack_public_path__ + "static/media/imgOne.85435d62.png";